export default __webpack_public_path__ + "static/media/gl_1.0fe3f214.png";